export const apiConstants = {
  BASE_URL_1: process.env.REACT_APP_API_URL,
  //Dev
  // BASE_URL_1: "https://dev1services.shotclasses.com",
  //Dev Staging
  //BASE_URL_1: "https://dev1services-staging.azurewebsites.net",
  //QA
  // BASE_URL_1: "https://qa-services.shotclasses.com",
  //Prod-EU
  // BASE_URL_1 : "https://services1.shotclasses.com",
  //Prod-US
  //BASE_URL_1 : "https://services2.shotclasses.com",
  //LTIM-Prod
  // BASE_URL_1 : "https://lighthouseservices.ltm.com",
  //Local Backend
  // BASE_URL_1 : "http://localhost:65422",

  ENV_NAME: {
    DEV: "DEV",
    QA: "QA",
    PROD: "PROD",
  },

  // ADAL_CONFIG: {
  //   O365_RESOURCE: "https://sceur.sharepoint.com",
  //   //Dev
  //   // CLIENT_ID: "0caaa908-39e0-457f-bade-3e2c6782a96c",
  //   // LOGIN_RESOURCE: "http://shotclassesdev.onmicrosoft.com/services",
  //   // APP_KEY: "R7kTFu~bJ6RlzPPb3.-SeMjsDnV71LyKO_",
  //   //QA
  //   //CLIENT_ID : '0caaa908-39e0-457f-bade-3e2c6782a96c',
  //   //LOGIN_RESOURCE : 'http://shotclassesdev.onmicrosoft.com/services',

  //   //Europe Prod
  //   // CLIENT_ID : "07e4c367-b387-47cb-8cdf-f550365cdf99",
  //   // LOGIN_RESOURCE : "https://prod1ad.onmicrosoft.com/api",

  //   //US Prod
  //   // CLIENT_ID : "0c8c1ef7-fba1-4d6d-acde-863f44ed8467",
  //   // LOGIN_RESOURCE : "https://prod1usad.onmicrosoft.com/api",
  // },
  MSAL_CONFIG: {
    O365_RESOURCE: "https://sceur.sharepoint.com",
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    LOGIN_RESOURCE: process.env.REACT_APP_LOGIN_RESOURCE,
    //Dev
    // CLIENT_ID: "0caaa908-39e0-457f-bade-3e2c6782a96c",
    // LOGIN_RESOURCE: "http://shotclassesdev.onmicrosoft.com/services",
    // APP_KEY: "R7kTFu~bJ6RlzPPb3.-SeMjsDnV71LyKO_",
    //QA
    // CLIENT_ID: "c9224796-917a-4d42-9bec-efa66317f5db",
    // LOGIN_RESOURCE:
    //   "api://shotclassesentraid.onmicrosoft.com/1847b815-1ad2-407c-b7f6-a3a71fa5a027",
    // APP_KEY : "KNr8Q~DBHIDfflYZUqH8KKXnA8uGO5mGRuGL.dp0",

    //Europe Prod
    // CLIENT_ID : "07e4c367-b387-47cb-8cdf-f550365cdf99",
    // LOGIN_RESOURCE : "https://prod1ad.onmicrosoft.com/api",
    // APP_KEY : "UdMldqsMDxPUrbTwCsOET7b2zL5MP4hL9pJl7YGW75k=",

    //US Prod
    // CLIENT_ID : "0c8c1ef7-fba1-4d6d-acde-863f44ed8467",
    // LOGIN_RESOURCE : "https://prod1usad.onmicrosoft.com/api",

    //LTIM-Prod
    // CLIENT_ID : "3bad5b5b-f85a-48da-ab80-a24105d66593",
    // LOGIN_RESOURCE : "api://ltimindtree.com/746b76d5-c030-4ce1-b06a-7624e8f138d1",
    // APP_KEY : "RJn8Q~h73JAagG2eBSf.pkwmWIyVURXURo_s3dgK",
  },
  COMMON: {
    GET_USER_ROLE_MENU: `/api/v1//Role/GetUserRoleMenu`,
    GET_TENANT_PERMISSION_INFO: `/api/v1//Role/GetTenantPermissionInfo`,
  },
  DASHBOARD: {
    GET_TRENDING_CLASSES: "/api/v3/ShotClasses/trending/none?Locale=en-GB",
  },

  LOGIN: {
    GET_TENANT_DETAILS: (tenantName) =>
      `/api/v1/Tenant/GetTenantDetails?TenantName=${tenantName}`,
    PRE_LOGIN: (tenantName, userName, isConsentRequired, isClientId) =>
      `/api/v3/Tenants/details?TenantName=${tenantName}${
        userName ? `&UserName=${userName}` : ""
      }${
        isConsentRequired
          ? ` &IsConsentRequired=${apiConstants.MSAL_CONFIG.CLIENT_ID}`
          : ""
      }${isClientId ? ` &ClientId=${apiConstants.MSAL_CONFIG.CLIENT_ID}` : ""}`,
    LOGIN: "/api/v1/Login/PostLoginToken",
    LOGIN2: "/api/v3/Logins/Token",
    IS_USER_EXISTS: (loginId, tenantName) =>
      `/api/v1/Login/IsUserIdExist?loginId=${loginId}&tenantName=${tenantName}`,
    IS_USER_ACTIVE: (loginId, tenantName) =>
      `/api/v1/Login/IsUserActive?loginId=${loginId}&tenantName=${tenantName}`,
    IS_PASSWORD_RESET_REQUIRED: "/api/v1/Login/PasswordResetRequired",
    FORGOT_PASSWORD: "/api/v1/Login/ForgotPassword",
    AAD_ADMIN_CONSENT: "/api/v1/AAD/PostAADAdminConsent",
    START_SESSION: "/api/v1/User/StartSession",
    END_SESSION: "/api/v1/User/EndSession",
    DELETE_USER_TOKEN: (loginId) =>
      "/api/v1/User/DeleteUserToken?loginId=" + loginId,
    REVOKE_TOKEN_ON_LOGOUT: "/api/v3/Logins/Logout",
  },

  LASTLOGIN: {
    LAST_LOGIN_TIME: `/api/v1/User/LastSessionEndTime`,
  },

  UserRoles: {
    GET_USER_ROLE_MENU: `/api/v1//Role/GetUserRoleMenu`,
  },

  TenantDetail: {
    GET_TENANT_PROFILE: `/api/v1/user/getprofile`,
  },

  PROFILE: {
    MY_PROFILE: `/api/v3/me/profile`,
    UPDATE_MY_PROFILE: `/api/v3/Users/userID`,
    RESET_PASSWORD: `/api/v3/Users/Password`,
    GET_CONTACT_US_PROFILE: `/api/v1/User/GetProfile`,
    POST_CONTACT_US_NEW_COMPLAINT: (data) =>
      `api/v1/Notification/CreateNewComplaint?data=${data}`,
    GET_USER_PROFILE: (userId = 0) =>
      `/api/v1/user/GetUserProfile?userId=${userId}`,
    GET_USER_GROUP_BY_USERID: (userId) =>
      `/api/v1/UserGroup/GetUserGroup?userId=${userId}`,
    PUT_MY_PROFILE: (isPswdChanged, tenantName, isCustomLogin) =>
      `/api/v1/user/PutMyProfile?isPswdChanged=${isPswdChanged}&tenantName=${tenantName}&isCustomLogin=${isCustomLogin}`,
  },

  ADMIN: {
    ORGANIZATION_SETTINGS: {
      GET_PASSWORD_EXPIRY_PERIOD: (tenantName = "") =>
        `/api/v1/Login/GetPasswordExpiry?tenantName=${tenantName}`,
      SET_PASSWORD_EXPIRY_PERIOD: (tenantName = "", days = 0) =>
        `/api/v1/Role/SetPasswordExpiry?tenantName=${tenantName}&days=${days}`,
      GET_USER_EMAIL_DETAILS: "/api/v1/Notification/GetContactUsEmailDetails",
      ADD_USER_EMAIL_DETAILS: "/api/v1/Notification/AddContactUsEmailDetails",
      IS_DOMAIN_NAME_EXIST: (domainName) =>
        `/api/v1//DomainName/IsDomainNameExists?domainName=${domainName}`,
      POST_DOMAIN_NAME: `/api/v1//DomainName/PostDomainName`,
      DELETE_DOMAIN_NAME: (id) =>
        `/api/v1//DomainName/DeleteDomainName?id=${id}`,
      PUT_DOMAIN_NAME: `/api/v1//DomainName/PutDomainName`,
      LATEST_IMPORT_STATUS: `/api/v1//Import/LatestImportStatus`,
      GET_LOCATION_LIST_CSV: (url) =>
        `/api/v1/Download/Export?url=${url}&template=getALllocations`,
      GET_USER_DEPARTMENT_LIST_CSV: (url) =>
        `/api/v1/Download/Export?url=${url}&template=GetAllUserDepartments`,
    },
    USER_MANAGEMENT: {
      GET_SEARCH_USERS: (searchText = "", pageNumber = 1, pageSize = 8) =>
        `/api/v1/User/Search?SearchText=${searchText}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      GET_USERS_STATUS: "/api/v1/User/GetUserStatus",
      IS_LOGINID_EXISTS: (loginId, tenantName) =>
        `/api/v1/User/IsUserIdExist?loginId=${loginId}&tenantName=${tenantName}`,
      UNLOCK_USER_ACCOUNT: "/api/v1/User/UnlockAccount",
      TOGGLE_USER_STATUS: (status) =>
        `/api/v1/User/UpdateUserActiveStatus?status=${status}`,
      GET_ALL_ROLES: "/api/v1/Role/GetAllRoles",
      POST_USER_PROFILE: (isCustomLogin = true) =>
        `/api/v1/user/postprofile?iscustomlogin=${isCustomLogin}`,
      GET_USER_PROFILE: (userId) =>
        `/api/v1/user/GetUserProfile?userId=${userId}`,
      GET_USER_GROUPS_BY_USERID: (userId) =>
        `/api/v1/UserGroup/GetUserGroupsByUserId?userId=${userId}`,
      PUT_USER_PROFILE: (isCustomLogin = true) =>
        `/api/v1/user/putprofile?iscustomlogin=${isCustomLogin}`,
      GET_USERS_LIST_CSV: (url) =>
        `/api/v1/Download/Export?url=${url}&template=GetAllActiveUsers`,
      GET_DOMAIN_NAMES: `/api/v1//DomainName/GetDomainNames`,
    },
    ROLES_AND_PERMISSION: {
      GET_ROLES_AND_PERMISSION: `/api/v1//Role/GetRolesandmenus`,
      POST_ROLE_MENU_MAPPING: `/api/v1//Role/PostRoleMenuMapping`,
      CHECK_ROLE_NAME: (name) => `/api/v1//Role/CheckRoleName?name=${name}`,
      CREATE_ROLE: `/api/v1//Role/PostRole`,
    },
    GROUP_MANAGEMENT: {
      GET_USER_GROUPS: (pageNum = 0, pageSize = 0, searchKey = "") => {
        if (pageNum && pageSize && searchKey)
          return `/api/v1/UserGroup/GetUserGroup?pageNum=${pageNum}&pageSize=${pageSize}&searchKey=${searchKey}`;
        else if (searchKey)
          return `/api/v1/UserGroup/GetUserGroup?searchKey=${searchKey}`;
        else
          return `/api/v1/UserGroup/GetUserGroup?pageNum=${pageNum}&pageSize=${pageSize}`;
      },
      POST_USER_GROUP: `/api/v1/UserGroup/PostUserGroup`,
      DELETE_GROUP: (id) => `/api/v1/UserGroup/DeleteUserGroup/${id}`,
      GET_USER_GROUP_MEMBERS: (userGroupId, allHierarchicalMembers) =>
        `/api/v1/UserGroup/GetMembers?userGroupId=${userGroupId}&allHierarchicalMembers=${allHierarchicalMembers}`,
      GET_USER_BY_NAME: (searchText) =>
        `/api/v1//Role/GetUserByName?searchText=${searchText}`,
      POST_MEMBER: (userGroupId) =>
        `/api/v1/UserGroup/PostMember?userGroupId=${userGroupId}`,
      DELETE_MEMBER: (userGroupId, userId) =>
        `/api/v1/UserGroup/DeleteMember?userGroupId=${userGroupId}&userId=${userId}`,
      GET_SUBGROUP_BY_ID: (id) => `/api/v1/UserGroup/GetUserGroup?id=${id}`,
      GET_SUBGROUP: (searchKey, isSearchToChildGroups, parentGroupId) =>
        `/api/v1/UserGroup/GetUserGroup?searchKey=${searchKey}&isSearchToChildGroups=${isSearchToChildGroups}&parentGroupId=${parentGroupId}`,
      SET_SUBGROUP: (id) => `/api/v1/UserGroup/PutUserGroup?id=${id}`,
      DELETE_SUBGROUP: (parentGroupId, subGroupId) =>
        `/api/v1/UserGroup/DeleteSubGroup?parentGroupId=${parentGroupId}&subGroupId=${subGroupId}`,
      SEARCH_CLASS: (SearchText, Status, condition) =>
        `/api/v1/ShotClass/SearchClass?SearchText=${SearchText}&Status=${Status}&condition=${condition}`,
      GET_USER_GROUPS_MANDATED_SHOTCLASSES: (
        classtype,
        pageNum,
        pageSize,
        usergroupid,
      ) =>
        `/api/v1/UserGroup/GetUsergroupsmandatedshotclasses?classtype=${classtype}&pageNum=${pageNum}&pageSize=${pageSize}&usergroupid=${usergroupid}`,
      DELETE_MANDATED_CLASSES: (classid, usergroupid) =>
        `/api/v1/UserGroup/DeleteMandatedClasses?classid=${classid}&usergroupid=${usergroupid}`,
      DELETE_MANDATED_PROGRAM: (programid, usergroupid) =>
        `/api/v1/UserGroup/DeleteMandatedProgram?programid=${programid}&usergroupid=${usergroupid}`,
      MANDATE_CLASSES: (classid, usergroupid, Isrepetitive, Frequency) =>
        `/api/v1/UserGroup/MandateClasses?classid=${classid}&usergroupid=${usergroupid}&Isrepetitive=${Isrepetitive}&Frequency=${Frequency}`,
      MANADATE_PROGRAM: (programid, usergroupid, Isrepetitive, Frequency) =>
        `/api/v1/UserGroup/MandateProgram?programid=${programid}&usergroupid=${usergroupid}&Isrepetitive=${Isrepetitive}&Frequency=${Frequency}`,
      SEARCH_PROGRAMS: (IsSkipduedateProgram, SearchText, Status) =>
        `/api/v1/ShotClass/SearchPrograms?IsSkipduedateProgram=${IsSkipduedateProgram}&SearchText=${SearchText}&Status=${Status}`,
      GET_CLASS_AND_COLLECTION_BY_PROGRAM_ID: (ProgramID, locale) =>
        `/api/v1/ShotClass/GetClassAndCollectionByProgramID?ProgramID=${ProgramID}&locale=${locale}`,
    },
    CERTIFICATE_MANAGEMENT: {
      GET_MANAGE_CERTIFICATES: (searchText = "", pageNum = 1, pageSize = 8) =>
        `/api/v1/Certificate/GetManageCertificates?pageNo=${pageNum}&pageSize=${pageSize}${
          searchText && `&searchText=${searchText}`
        }`,
      DELETE_CERTIFICATE: (certificateId) =>
        `/api/v1/Certificate/DeleteCertificate?id=${certificateId}`,
      UPLOAD_CERTIFICATE: (fileName) =>
        `/api/v1/Certificate/PostUploadCertificate?fileName=${fileName}`,
      POST_NEW_CERTIFICATE: "/api/v1/Certificate/PostNewCertificate",
      POST_EDIT_CERTIFICATE: "/api/v1/Certificate/PostEditCertificate",
    },
    ALL_ROLES: {
      GET_ALL_ROLES: `api/v1//Role/GetAllRoles`,
      GET_USER_ROLES: (lUserId) =>
        `api/v1//Role/GetUserRoles?lUserId=${lUserId}`,
      ASSIGN_USER_TO_ROLES: `api/v1//Role/AssignUsertoRoles`,
    },
    EMAIL_TRIGGER: {
      SEND_TO_QUEUE: `api/v1//Triggers/SendToQueue`,
    },
    ENGAGEMENT_CENTER: {
      GET_ALL_NOTIFICATIONS: (searchText = "", pageNo = 1, pageSize = 8) =>
        `/api/v1/CampaignNotification/GetAllNotifications?pageNo=${pageNo}&pageSize=${pageSize}${
          searchText && `&searchText=${searchText}`
        }`,
      TRIGGER_NOTIFICATION: `/api/v1/CampaignNotification/TriggerAdhocNotification`,
      DELETE_NOTIFICATION: (campaignNotificationId) =>
        `/api/v1/CampaignNotification/DeleteCampaignNotification?campaignNotificationId=${campaignNotificationId}`,
      GET_ALL_NOTIFICATIONS_HISTORY: (
        searchText = "",
        pageNo = 1,
        pageSize = 8,
        from = "",
        to = "",
      ) =>
        `/api/v1/CampaignNotificationLog/GetAllNotificationLogs?pageNo=${pageNo}&pageSize=${pageSize}${
          searchText && `&searchText=${searchText}`
        }${from && to ? `&from=${from}&to=${to}` : ``}`,
      GET_NOTIFICATION_BY_ID: (campaignNotificationId) =>
        `/api/v1/CampaignNotification/GetCampaignNotification?id=${campaignNotificationId}`,
      GET_NOTIFICATION_MODE: `/api/v1/MasterData/GetNotificationMode`,
      GET_NOTIFICATION_TEMPLATE: `/api/v1/MasterData/GetNotificationTemplate`,
      GET_NOTIFICATION_TYPE: `/api/v1/MasterData/GetNotificationType`,
      GET_NOTIFICATION_FREQUENCY: `/api/v1/MasterData/GetNotificationEventFrequency`,
      GET_NOTIFICATION_PLACEHOLDERS: `/api/v1/MasterData/GetPlaceHolders`,
      GET_NOTIFICATION_PLACEHOLDER_EVENTS: `/api/v1/MasterData/GetPlaceHoldertEvents`,
      GET_NOTIFICATION_EVENT: (
        isEventBased = false,
        isAdhoc = true,
        isAuto = false,
      ) =>
        `/api/v1/MasterData/GetEvents?isEventBased=${isEventBased}&isAdhoc=${isAdhoc}&isAuto=${isAuto}`,
      GET_NOTIFICATION_EVENT_VALUES: (eventId) =>
        `/api/v1/MasterData/GetEventValues?eventId=${eventId}`,
      GET_PLACEHOLDER_EVENT_VALUES: (eventId) =>
        `/api/v1/MasterData/GetPlaceHolderEventValues?placeHolderEventId=${eventId}`,
      GET_LANDING_PAGES: `/api/v1/MasterData/GetLandingPages`,
      UPDATE_NOTIFICATION: `/api/v1/CampaignNotification/UpdateCampaignNotification`,
      GET_NOTIFICATION_HISTORY_CSV: (url) =>
        `/api/v1/Download/Export?url=${url}&template=NotificationDistibutionLogReport`,
    },
    MY_QUERIES: {
      GET_ALL_ASSIGNED_QUERIES: (
        queryCategory = "SHOTCLASS",
        epoch = 0,
        pageSize = 50,
      ) =>
        `api/v1/LearnerQuery/GetAllAssignedQueries?queryCategory=${queryCategory}&epoch=${epoch}&pageSize=${pageSize}`,
      GET_ALL_ASSIGNED_QUERIES_SUPPORT_TAB: (
        queryCategory = "GENERAL",
        epoch = 0,
        pageSize = 50,
      ) =>
        `api/v1/LearnerQuery/GetAllAssignedQueries?queryCategory=${queryCategory}&epoch=${epoch}&pageSize=${pageSize}`,
      DELETE_QUERY: `api/v1/LearnerQuery/DeleteQuery`,
      PUT_Query: (IsQueryFromMobileUser = "false") =>
        `api/v1/LearnerQuery/PutQuery?IsQueryFromMobileUser=${IsQueryFromMobileUser}`,
      PUT_UNREAD_COUNT: `api/v1/LearnerQuery/PutUnreadCount`,
      PUT_IS_READ: (queryId, IsMobileUser = false) =>
        `api/v1/LearnerQuery/PutIsRead?queryId=${queryId}&IsMobileUser=${IsMobileUser}`,
    },
  },

  MANAGE: {
    //manage main page
    GET_CLASS_BY_STATUS: (
      status = "",
      searchText = "",
      pageNumber = 1,
      pageSize = 8,
    ) =>
      `/api/v1/ShotClass/${
        searchText ? "SearchClassByUser" : "GetClassByStatus"
      }?Status=${status}&SearchText=${searchText}&pageNum=${pageNumber}&pageSize=${pageSize}`,
    GET_TRANSCRIPTION_DETAILS: (
      searchText = "",
      pageNumber = 1,
      pageSize = 8,
    ) =>
      `/api/v3/SemanticSearchs/shotclasses/${
        searchText ? "searchTranscribe" : "transcribeDetails"
      }?SearchText=${searchText}&pageNum=${pageNumber}&pageSize=${pageSize}`,
    DELETE_SHOTCLASS: (shotclassId) =>
      `/api/v1/ShotClass/DeleteShotClass?classId=${shotclassId}`,
    TRANSCRIBE_SHOTCLASS: (shotclassId) =>
      `/api/v3/SemanticSearchs/shotclasses/${shotclassId}/transcribe`,

    //add training type
    GET_TRAINING_TYPES: `/api/v1/TrainingType/GetTrainingTypeList`,
    IS_TRAINING_TYPE_EXISTS: (trainingName) =>
      `/api/v1/TrainingType/IsTrainingTypeNameExists?name=${trainingName}`,
    ADD_TRAINING_TYPES: `/api/v1/TrainingType/PostTrainingType`,
    DELETE_TRAINING_TYPES: (trainingTypeId) =>
      `/api/v1/TrainingType/DeleteTrainingType?id=${trainingTypeId}`,

    //content bulk upload
    //file upload
    UPLOAD_CSV_FILE: (typeOfCSVFlag) =>
      `/api/v1/CsvUpload/UploadCsv?typeOfCsvFlag=${typeOfCSVFlag}`,
    // blob url upload
    UPLOAD_CSV_URL_WITH_QUEUE: `/api/v1/CsvUpload/AddToQueue`,
    GET_CSV_LAST_UPLOAD_DATE: (fileName, isCustomLogin) =>
      `/api/v1/CsvUpload/GetCsvLastUploadedDate?csvFileName=${fileName}&iscustomlogin=${isCustomLogin}`,
    GET_QUIZ_IMAGES: (status = "Published", pageNumber = 1, pageSize = 15) =>
      `/api/v1/image/GetQuizMediaFiles?Status=${status}&pageNum=${pageNumber}&pageSize=${pageSize}`,
    GET_EXISTING_QUIZ_IMAGES: `/api/v1/image/GetMultiImageList`,
    DELETE_QUIZ_IMAGE: (imageName) =>
      `/api/v1/image/DeleteQuizMediaFiles/?ImageName=${imageName}`,
    POST_MULTI_QUIZ_IMAGES: `/api/v1/image/PostMultiImage?files=`,

    //create shotclass
    IS_NAME_EXISTS: (name, type = "ShotClass") =>
      `/api/v1/ShotClass/IsNameExists?name=${name}&type=${type}`,
    GET_SEARCH_CLASS_TAGS: (searchTerm) =>
      `/api/v1/ShotClass/GetSearchClassTags?searchText=${searchTerm}`,
    GET_ALL_VARIANT_LANGUAGES: `/api/v1/MasterLanguage/GetAllVariantLanguages`,
    GET_USER_GROUPS: `/api/v1/UserGroup/GetUserGroup`,
    GET_YOUTUBE_VIDEOS: (searchTerm = "", pageNum = 1, pageSize = 10) =>
      `/api/v3/Videos/youtubevideos?searchTerm=${searchTerm}&pageNo=${pageNum}&pageSize=${pageSize}`,
    GET_ONLINE_COURSES: (searchTerm = "") =>
      `/api/v1/MoocCourse/Get?strSearchText=${searchTerm}`,
    GET_SLIDESHARES: (searchTerm = "") =>
      `/api/v1/Video/GetSlideshare?searchTerm=${searchTerm}`,
    GET_CLASSDETAILS_BY_ID: (shotclassId, status = "") =>
      `/api/v1/ShotClass/GetClassDetails?id=${shotclassId}${
        status && "&status=" + status
      }`,
    CREATE_SHOTCLASS: `/api/v1/shotclass/postclass`,
    UPLOAD_PPT_SHOTCLASS: (
      classId,
      fileExtension,
      isVariant = false,
      status = "Published",
    ) =>
      `/api/v1/ppt/UploadPptAndSave?classId=+${classId}&fileExtension=${fileExtension}&isVariant=${isVariant}&status=${status}`,
    UPLOAD_PDF_SHOTCLASS: (
      classId,
      fileExtension,
      isVariant = false,
      status = "Published",
    ) =>
      `/api/v1/ppt/UploadMediaContent?classId=+${classId}&fileExtension=${fileExtension}&isVariant=${isVariant}&status=${status}`,
    UPLOAD_SLIDESHARE_SHOTCLASS: `/api/v1/Video/UpdateClassDetails`,
    UPLOAD_SCORM_OR_HTML_SHOTCLASS: (
      isHTML,
      classId,
      fileExtension,
      fileName,
      isVariant = false,
      status = "Published",
    ) =>
      `/api/v1/${
        isHTML ? "html5" : "scorm"
      }/Post?classId=+${classId}&fileExtension=${fileExtension}&fileName=${fileName}&isVariant=${isVariant}&status=${status}`,
    GET_STORED_MEDIA_INFO: (classId) =>
      `/api/v1/MediaService/GetStoredMediaInfo?classId=+${classId}`,
    SET_METADATA_FOR_VIDEO: (numberOfBlocks, fileName, fileSize, className) =>
      `/api/v1/Video/setMetadata?blocksCount=${numberOfBlocks}&fileName=${fileName}&fileSize=${fileSize}&className=${className}`,
    UPLOAD_VIDEO_CHUNK: (currentChunk, uploadChunkObject) =>
      `/api/v1/Video/UploadChunk?chunkId=${currentChunk}&VideoGuid=${uploadChunkObject.videoGuid}&classIdTemp=${uploadChunkObject.classId}&isVariant=${uploadChunkObject.isVariant}&status=${uploadChunkObject.status}&fileName=${uploadChunkObject.fileName}&url=${uploadChunkObject.url}&size=${uploadChunkObject.fileSize}&blockCount=${uploadChunkObject.blockCount}&uploadStatusMessage=${uploadChunkObject.uploadStatusMessage}&isUploadCompleted=${uploadChunkObject.isUploadCompleted}&isShotClassSourcingFromLearner=${uploadChunkObject.isShotClassSourcingFromLearner}`,
    USER_CANCELLED_VIDEO_UPLOAD: (strGuid) =>
      `/api/v1/Video/UserCancelledVideoUpload?strGuid=${strGuid}`,
    ADD_TO_QUEUE_VIDEO: `/api/v1/Video/AddToQueue`,
    UPLOAD_CALANDER_FILE: (classId, fileExtension) =>
      `api/v1/UploadCalendarFile?classId=${classId}&fileExtension=${fileExtension}`,

    //update shotclass
    UPDATE_SHOTCLASS: `/api/v1/shotclass/UpdateShotClass`,
    DELETE_QUIZ_QUESTION: (questionId) =>
      `/api/v1/ShotClass/DeleteQuestion?questionId=${questionId}`,
    //copy shotclass
    COPY_SHOTCLASS: `/api/v1/shotclass/CopyClass`,

    //view content
    //get media token
    GET_VIDEO_MEDIA_TOKEN: (assetId) =>
      `/api/v1/MediaService/GetToken?assetId=${assetId}`,

    //edit transcribe shotclass
    GET_SEMANTIC_SEARCH_SECTION_BY_ID: (shotclassId) =>
      `/api/v3/SemanticSearchs/shotclasses/sections?classId=${shotclassId}`,
    GET_SEMANTIC_SEARCH_BY_ID: (shotclassId) =>
      `/api/v3/SemanticSearchs/shotclasses?classId=${shotclassId}`,
    UPDATE_TRANSCIBE_SHOTCLASS: `/api/v3/SemanticSearchs/update/transcribe`,
  },
  EVENTS: {
    GET_CLASS_BY_STATUS: (
      status = "",
      searchText = "",
      pageNumber = 1,
      pageSize = 8,
      condition = "",
    ) =>
      `/api/v1/ShotClass/${
        searchText ? "SearchEventByUser" : "GetEventClassByStatus"
      }?condition=${condition}&Status=${status}&SearchText=${searchText}&pageNum=${pageNumber}&pageSize=${pageSize}`,

    DELETE_SHOTCLASS: (shotclassId) =>
      `/api/v1/ShotClass/DeleteShotClass?classId=${shotclassId}`,
    GET_USER_BY_NAME: (searchText) =>
      `api/v1//Role/GetUserByName?searchText=${searchText}`,
    GET_CLASS_BY_TAG_LiveTraining: `api/v1//ShotClass/GetClassByTag?pageNum=0&pageSize=0&tag=LiveTraining`,
    GET_CLASS_BY_TAG_VirtualTraining: `api/v1//ShotClass/GetClassByTag?pageNum=0&pageSize=0&tag=VirtualTraining`,
    POST_LIVE_QUIZ_EVENT: `api/v1//LiveQuizEvent/PostLiveQuizEvent`,
  },
  DISTRIBUTE: {
    GET_ALL_PROGRAMS_COUNT: (Condition, Status, ShotClass) =>
      `/api/v1/ShotClass/GetAllProgramsCountWithCondition?Condition=${Condition}&Status=${Status}&classtype=${ShotClass}`,
    GET_SHORTCLASSES: (
      Condition,
      Isdistributefilter,
      Status,
      classtype,
      filters,
      locale,
      pageNum,
      pageSize,
    ) =>
      `/api/v1/ShotClass/GetRecentlyAddedPrograms?Condition=${Condition}&Isdistributefilter=${Isdistributefilter}&Status=${Status}&classtype=${classtype}&filters=${filters}&locale=${locale}&pageNum=${pageNum}&pageSize=${pageSize}`,
    GET_ALL_PUBLISHED_BY_ME: (
      Condition,
      Status,
      classtype,
      filters,
      locale,
      pageNum,
      pageSize,
    ) =>
      `/api/v1/ShotClass/GetRecentlyAddedPrograms?Condition=${Condition}&Status=${Status}&classtype=${classtype}&filters=${filters}&locale=${locale}&pageNum=${pageNum}&pageSize=${pageSize}`,
    GET_CLASS_BY_STATUS_WITH_CONDITION: (
      Condition,
      Status,
      pageNum,
      pageSize,
    ) =>
      `/api/v1/ShotClass/GetClassByStatusWithCondition?Condition=${Condition}&Status=${Status}&pageNum=${pageNum}&pageSize=${pageSize}`,
    GET_DISTRIBUTUTION_HISTORY: (pageSize, pageNum) =>
      `/api/v1/Distribute/GetDistributionHistory?pageNum=${pageNum}&pageSize=${pageSize}`,
    GET_SEARCH_SHOTCLASSES: (
      IsDistributed,
      IsPartOfProgram,
      SearchText,
      Status,
    ) =>
      `/api/v1/ShotClass/GetSearchClasses?IsDistributed=${IsDistributed}&IsPartOfProgram=${IsPartOfProgram}&SearchText=${SearchText}&Status=${Status}`,
    GET_USER_CLASS_ASSIGNMENT: (
      classId,
      pageNum,
      pageSize,
      fromDate,
      toDate,
      userId,
      type,
    ) =>
      `/api/v1//Distribute/${
        type === "class" ? "GetUserClassAssignments" : "GetUserAssignments"
      }?pageNum=${pageNum}&pageSize=${pageSize}${
        fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : ``
      }${classId ? `&classId=${classId}` : `&classId=0`}${
        userId ? `&userId=${userId}` : `&userId=0`
      }`,
    PUT_ASSIGNED_CLASSES: `/api/v1//Distribute/PutAssignedClasses`,
    ARCHIVE_CLASSES: `/api/v1//Distribute/ArchiveClasses`,
    GET_USER_BY_NAME: (SearchText, Status) =>
      `/api/v1//Role/GetUserByName?SearchText=${SearchText}&Status=${Status}`,
    GET_PROGRAM_DISTRIBUTION_HISTORY: (programid) =>
      `/api/v1/ShotClass/GetProgramDistributionHistory?programid=${programid}`,
    DELTE_PROGRAM: (ProgramID) =>
      `/api/v1/ShotClass/DeleteProgram?ProgramID=${ProgramID}`,
    DELETE_COLLECTION: (CollectionID) =>
      `/api/v1/ShotClass/DeleteCollection?CollectionID=${CollectionID}`,
    DISTRIBUTE_CLASSES: () => `/api/v1/Distribute/DistributeClasses`,
    WORK_OR_OFFICE_LOCATION_LIST: `/api/v1/Location/GetStoreList`,
    GET_STORE_LIST_BY_STORE_ID: (StoreId) =>
      `/api/v1/Location/GetStoreList?StoreId=${StoreId}`,
    GET_STORE_LIST_BY_COUNTRY_ID: (CountryId) =>
      `/api/v1/Location/GetStoreList?CountryId=${CountryId}`,
    POST_COLLECTION: `/api/v1/ShotClass/PostCollection`,
    GET_CERTIFICATE: `/api/v1/Certificate/GetCertificates`,
    POST_CERTIFICATE: `/api/v1/Certificate/PostCertificate`,
    GET_CERTIFICATE_BY_PROGRAMID: (programId) =>
      `/api/v1/Certificate/GetCertificatebyProgramId?programId=${programId}`,
  },
  ORGANIZE: {
    GET_ALL_GROUP_TOPICS: (searchText = "", pageNo = 1, pageSize = 8) =>
      `/api/v1/Topic/GetAllGroupTopics?pageNo=${pageNo}&pageSize=${pageSize}${
        searchText && `&searchText=${searchText}`
      }`,
    GET_ALL_TOPICS: (searchText = "", pageNo, pageSize) =>
      `/api/v1/Topic/GetAllTopics?pageNo=${pageNo}&pageSize=${pageSize}${
        searchText && `&searchText=${searchText}`
      }`,
    GET_RECENTLY_ADDED_PROGRAMS: (
      Condition,
      Status,
      classtype,
      filters,
      isPublishedContentOnly,
      locale,
      pageNum,
      pageSize,
    ) =>
      `/api/v1/ShotClass/GetRecentlyAddedPrograms?Condition=${Condition}&Status=${Status}&classtype=${classtype}&filters=${filters}${
        isPublishedContentOnly
          ? `&isPublishedContentOnly=${isPublishedContentOnly}`
          : ""
      }&locale=${locale}&pageNum=${pageNum}&pageSize=${pageSize}`,
    GET_RECENTLY_ADDED_PROGRAMS_SERIES_MGMT: (
      Condition,
      Status,
      classtype,
      filters,
      locale,
      pageNum,
      pageSize,
    ) =>
      `/api/v1/ShotClass/GetRecentlyAddedPrograms?Condition=${Condition}&Status=${Status}&classtype=${classtype}&filters=${filters}&locale=${locale}&pageNum=${pageNum}&pageSize=${pageSize}`,
    POST_IMAGE: `/api/v1/image/postimage`,
    ADD_GROUP_TOPIC: `/api/v1/Topic/AddGroupTopic`,
    ADD_TOPIC: `/api/v1/Topic/AddTopic`,
    GET_SEARCH_TOPIC_TAGS: (searchText) =>
      `/api/v1/Topic/GetSearchTopicTags?searchText=${searchText}`,
    IS_TOPIC_EXISTS: (searchText) =>
      `/api/v1/Topic/IsTopicExists?searchText=${searchText}`,
    GET_TOPIC_DETAILS_BY_PROGRAM_ID: (programId) =>
      `/api/v1/ShotClass/GetTopicDetailsByProgramID?programId=${programId}`,
    UPDATE_PROGRAM: `/api/v1/ShotClass/UpdateProgram`,
    GET_ALL_PROGRAMS_COUNT_ORGANIZE_WITHOUTCONDITION: (
      status,
      classtype,
      filters = "",
    ) =>
      `/api/v1/ShotClass/GetAllProgramsCount?Status=${status}&classtype=${classtype}${
        filters && `&filters=${filters}`
      }`,
    GET_SEARCH_PROGRAM_TAGS: (searchText) =>
      `/api/v1/ShotClass/GetSearchProgramTags?searchText=${searchText}`,
    POST_SERIES_PROGRAM: `/api/v1/ShotClass/PostProgram`,
    GET_TOPIC_BY_ID: (topicId) => `/api/v1/Topic/GetTopic?topicId=${topicId}`,
    DELETE_TOPIC_BY_ID: (topicId) =>
      `/api/v1/Topic/DeleteTopic?topicId=${topicId}`,
    UPDATE_TOPIC: `/api/v1/Topic/UpdateTopic`,
    GET_GROUP_TOPIC_BY_ID: (groupTopicId) =>
      `/api/v1/Topic/GetGroupTopic?groupTopicId=${groupTopicId}`,
    UPDATE_GROUP_TOPIC: `/api/v1/Topic/UpdateGroupTopic`,
    SEARCH_SERIES_PROGRAM: (SearchText, Status, locale, condition) =>
      `/api/v1/ShotClass/SearchPrograms?SearchText=${SearchText}&Status=${Status}&locale=${locale}${
        condition ? `&condition=${condition}` : ""
      }`,
    POST_CERTIFICATE: `/api/v1/Certificate/EditCertificate`,
  },

  SOCIAL: {
    GET_MY_POLLS: "/api/v1/Poll/GetMyPolls",
    GET_ALL_POLLS: "/api/v1/Poll/GetAllPolls",
    POST_IMAGE: "/api/v1/image/postimage",
    POST_POLL: "/api/v1/Poll/PostPoll",
    EDIT_POLL: "/api/v1/Poll/EditPoll",
    DELETE_POLL: "/api/v1/Poll/DeletePollByPollId",
    COPY_POLL: "/api/v1/Poll/CopyPoll",
    LOCK_POLL: "/api/v1/Poll/LockPollByPollId",
    UNLOCK_POLL: "/api/v1/Poll/UnLockPollByPollId",
    DISTRIBUTE_POLL: "/api/v1/Poll/DistributePoll",
    DOWNLOAD_POLL_RESULT: (url, template = "PollResultCSV") =>
      `/api/v1/Download/Export?url=${url}&template=${template}`,
    POLL_RESULT: (id, time) =>
      `/api/v1/Poll/GetPollUsageByPollId?id=${id}&getTime=${time}`,
    POLL_RESULT_BY_GROUP_ID: (id, time, groupId) =>
      `/api/v1/Poll/GetPollUsageByGroupId?id=${id}&groupId=${groupId}&getTime=${time}`,
    GET_POLL_BY_ID: (pollId, time) =>
      `/api/v1/Poll/GetPollByPollId?id=${pollId}&getTime=${time}`,
    IS_POLL_EXIST: (id, name) =>
      `/api/v1/Poll/IsPollExists?id=${id}&name=${name}`,
    TENANT_POLLU_USERS_INFO: "/api/v1//User/GetTenantUsersInfoForPoll",
    POLL_USER_GROUP: "/api/v1/UserGroup/GetUserGroup",
    SEARCH_POLL_USER: (SearchText) =>
      `/api/v1//User/Search?SearchText=${SearchText}&pageNumber=1&pageSize=1000`,
    SEARCH_POLL_GROUP: (searchKey) =>
      `/api/v1/UserGroup/GetUserGroup?pageNum=1&pageSize=1000&searchKey=${searchKey}`,
    FORUM_AREA: {
      FORUM_TOPICS: (pageNum, pageSize) =>
        `/api/v1/Forum/GetForumTopics?pageNum=${pageNum}&pageSize=${pageSize}`,
      FORUM_THREADS: (TopicId, pageNum, pageSize) =>
        `/api/v1/Forum/GetForumThreads?TopicId=${TopicId}&pageNum=${pageNum}&pageSize=${pageSize}`,
      FORUM_COMMENTS: (ThreadId, pageNum, pageSize) =>
        `api/v1/Forum/GetForumComments?ThreadId=${ThreadId}&pageNum=${pageNum}&pageSize=${pageSize}`,
      CREATE_FORUM_TOPIC: "/api/v1/Forum/CreateForumTopics",
      EDIT_FORUM_TOPIC: "/api/v1/Forum/PutForumTopic",
      UPDATE_FORUM_TOPIC: "/api/v1/Forum/UpdateForumTopics",
      CREATE_FORUM_THREAD: "/api/v1/Forum/CreateForumThread",
      UPDATE_FORUM_THREAD: "/api/v1/Forum/UpdateForumThread",
      CREATE_FORUM_COMMENT: "/api/v1/Forum/CreateForumComment",
      UPDATE_FORUM_COMMENT: "/api/v1/Forum/UpdateForumComment",
    },
    MODERATE_CONTRIBUTIONS: {
      GET_SUBMISSIONS_DATA: (pageNum, pageSize, searchText) =>
        `/api/v1/ShotClassSourcing/GetSubmittedContent?Status=Rejected&pageNum=${pageNum}&pageSize=${pageSize}${
          searchText ? `&searchText=${searchText}` : ""
        }`,
      GET_MY_MODERATION_DATA: (pageNum, pageSize, searchText) =>
        `/api/v1/ShotClassSourcing/GetMyModurationContent?Status=Rejected&pageNum=${pageNum}&pageSize=${pageSize}${
          searchText ? `&searchText=${searchText}` : ""
        }`,
      GET_LOCK_BY_OTHERS_DATA: (pageNum, pageSize, searchText) =>
        `/api/v1/ShotClassSourcing/GetContentLockedByOthers?Status=Rejected&pageNum=${pageNum}&pageSize=${pageSize}${
          searchText ? `&searchText=${searchText}` : ""
        }`,
      GET_REJECTED_DATA: (pageNum, pageSize, searchText) =>
        `/api/v1/ShotClassSourcing/GetAllRejectContents?Status=Rejected&pageNum=${pageNum}&pageSize=${pageSize}${
          searchText ? `&searchText=${searchText}` : ""
        }`,
      GET_PUBLISHED_DATA: (pageNum, pageSize, searchText) =>
        `/api/v1/ShotClass/GetClassByStatus?Status=Published&pageNum=${pageNum}&pageSize=${pageSize}${
          searchText ? `&searchText=${searchText}` : ""
        }`,
      GET_PUBLISHED_BY_OTHERS: (pageNum, pageSize, searchText) =>
        `/api/v1/ShotClass/GetClassByStatus?Status=PublishedByothers&pageNum=${pageNum}&pageSize=${pageSize}${
          searchText ? `&searchText=${searchText}` : ""
        }`,
      GET_SHOTCLASS_SOURCING_CLASS_DETAILS_BY_ID: (id, status) =>
        `/api/v1/ShotClassSourcing/GetClassDetails?id=${id}&status=${status}`,
      GET_MODERATOR_CONTRIBUTOR_COMMENTS: (id) =>
        `/api/v1/ShotClassSourcing/GetContributorModeratorComments?classId=${id}`,
      POST_CONTRIBUTOR_MODERATOR_COMMENTS: (classId, comments, isContributor) =>
        `/api/v1/ShotClassSourcing/PostGetContributorModeratorComments?classId=${classId}&comments=${comments}&isContributor=${isContributor}`,
      LOCK_CONTRIBUTOR_SHOTCLASS: (classid) =>
        `/api/v1/ShotClassSourcing/LockContributorShotClass?classid=${classid}`,
      UNLOCK_CONTRIBUTOR_SHOTCLASSES: (classid) =>
        `/api/v1/ShotClassSourcing/UnLockContributorShotClass?classid=${classid}`,
      REJECT_SHOTCLASS: (classid) =>
        `/api/v1/ShotClassSourcing/RejectShotClass?classid=${classid}`,
      UPDATE_SHOTCLASS: `/api/v1/ShotClassSourcing/UpdateShotClass`,
    },
  },
  REPORT: {
    COMMON: {
      GET_TENANT_USERS: `/api/v1//User/GetTenantUsersInfo`,
      GET_TRAINING_TYPES: `/api/v1//TrainingType/GetTrainingTypeList`,
      GET_CLASS_NAME: `api/v1//Reports/AdoptionReport/GetClassName`,
      GET_USER_GROUP: `/api/v1//Reports/AdoptionReport/GetUserGroups`,
    },
    CSV_REPORT: (reportUrl, template) =>
      `/api/v1/Download/Export?url=${reportUrl}${
        template.length > 0 ? "&template=" + template : ""
      }`,
    CSV_SURVEY_REPORT: (reportUrl, template) =>
      `/api/v1/Download/ExportSurveyReport?url=${reportUrl}${
        template.length > 0 ? "&template=" + template : ""
      }`,

    GRAPHICAL_REPORT: {
      GET_USER_VISUAL_REPORT: `/api/v1//VisualReports/UserVisualReport/GetdefaultLPRC`,
      GET_USER_DISTRIBUTION_SUMMARY: `/api/v1//VisualReports/UserVisualReport/GetdefaultInfo`,
      GET_CLASS_DISTRIBUTION_SUMMARY: `/api/v1//VisualReports/UserVisualReport/GetdefaultClassInfo`,
      GET_CLASS_VISUAL_REPORT: `api/v1//VisualReports/UserVisualReport/GetdefaultClassMostResponse`,
      GET_ASSIGNED_CLASS: `/api/v1//VisualReports/UserVisualReport/GetAssignedClassesInfo`,
      FILTER_USER_VISUAL_REPORT: `/api/v1//VisualReports/UserVisualReport/PostMostUserResponseWithFilters`,
      FILTER_USER_DISTRIBUTION_SUMMARY: `/api/v1//VisualReports/UserVisualReport/PostDataWithFilter`,
      FILTER_CLASS_VISUAL_REPORT: `/api/v1//VisualReports/UserVisualReport/PostClassMostLPRCWithFilters`,
      FILTER_CLASS_DISTRIBUTION_SUMMARY: `/api/v1//VisualReports/UserVisualReport/PostClassDataWithFilter`,
    },
    TABULAR_REPORT: {
      USER_DISTRIBUTION_REPORT: (
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        reportMode,
        toDate,
        trainingType,
        user,
      ) => {
        if (reportMode === "Extract")
          return `/api/v1//Reports/UserReport/UserDistributionReport?reportMode=${reportMode}&pageNum=${pageNumber}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&trainingType=${trainingType}&user=${user}`;
        else
          return `/api/v1//Reports/UserReport/UserDistributionReport?fromDate=${fromDate}&pageNum=${pageNumber}&pageSize=${pageSize}&reportMode=${reportMode}&toDate=${toDate}&trainingType=${trainingType}&user=${user}`;
      },
      CLASS_DISTRIBUTION_REPORT: (
        className,
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        reportMode,
        toDate,
        trainingType,
      ) => {
        if (reportMode === "Extract")
          return `/api/v1//Reports/ShotClassReport/ClassDistributionReport?reportMode=${reportMode}&pageNum=${pageNumber}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&trainingType=${trainingType}&className=${className}`;
        else
          return `/api/v1//Reports/ShotClassReport/ClassDistributionReport?className=${className}&fromDate=${fromDate}&pageNum=${pageNumber}&pageSize=${pageSize}&reportMode=${reportMode}&toDate=${toDate}&trainingType=${trainingType}`;
      },
      SEND_REMAINDER: (ClassId) =>
        `/api/v1/Reminder/SendRemainder?classId=${ClassId}`,

      USER_SHOTCLASS_REPORT: (
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        reportMode,
        toDate,
        trainingType,
        userId,
      ) => {
        if (reportMode === "Extract")
          return `/api/v1//Reports/UserReport/UserShotClassReport?userId=${userId}&reportMode=${reportMode}&pageNum=${pageNumber}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&trainingType=${trainingType}`;
        else
          return `/api/v1//Reports/UserReport/UserShotClassReport?fromDate=${fromDate}&pageNum=${pageNumber}&pageSize=${pageSize}&reportMode=${reportMode}&toDate=${toDate}&trainingType=${trainingType}&userId=${userId}`;
      },

      SHOTCLASS_USER_REPORT: (
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        reportMode,
        shotClass,
        toDate,
        trainingType,
      ) => {
        if (reportMode === "Extract")
          return `/api/v1//Reports/ShotClassReport/ShotClassUserReport?shotClassId=${shotClass}&reportMode=${reportMode}&pageNum=${pageNumber}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&trainingType=${trainingType}`;
        else
          return `/api/v1//Reports/ShotClassReport/ShotClassUserReport?fromDate=${fromDate}&pageNum=${pageNumber}&pageSize=${pageSize}&reportMode=${reportMode}&shotClassId=${shotClass}&toDate=${toDate}&trainingType=${trainingType}`;
      },

      GET_COUNTRY_LIST: `/api/v1/Location/GetCountryList`,
      GET_STATE_LIST: (countryId) =>
        `/api/v1/Location/GetStateList?CountryId=${countryId}`,
      GET_CITY_LIST: (stateId) =>
        `/api/v1/Location/GetCityList?StateId=${stateId}`,
      GET_WORK_OFFICE_LIST: (cityId) =>
        `/api/v1/Location/GetStoreList?CityId=${cityId}`,
      GET_PRODUCT_CATEGORY_LIST: `/api/v1/ProductCategory/GetProductCategoryList`,

      GET_USER_CLASS_COMPLETION_GRAPH_REPORT: (
        categoryId,
        cityId,
        classId,
        countryId,
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        stateId,
        toDate,
        workOfficeId,
        trainingType,
        userLoginId,
        userGroupId,
      ) => {
        if (fromDate && toDate)
          return `/api/v1//UserBasedReports/GetUserClassCompletionGraphReport?CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}&FromDate=${fromDate}&PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${workOfficeId}&ToDate=${toDate}&TrainingTypeId=${trainingType}&UserLoginIds=${userLoginId}&UsergroupId=${userGroupId}`;
        else if (categoryId)
          return `/api/v1//UserBasedReports/GetUserClassCompletionGraphReport?CategoryId=${categoryId}&CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}&PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${workOfficeId}&TrainingTypeId=${trainingType}&UserLoginIds=${userLoginId}&UsergroupId=${userGroupId}`;
        else
          return `/api/v1//UserBasedReports/GetUserClassCompletionGraphReport?CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}&PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${workOfficeId}&TrainingTypeId=${trainingType}&UserLoginIds=${userLoginId}&UsergroupId=${userGroupId}`;
      },

      GET_USER_CLASS_COMPLETION_REPORT: (
        categoryId,
        cityId,
        classId,
        countryId,
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        stateId,
        toDate,
        workOfficeId,
        trainingType,
        userLoginId,
        userGroupId,
      ) => {
        if (fromDate && toDate)
          return `/api/v1//UserBasedReports/GetUserClassCompletionReport?CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}&FromDate=${fromDate}&PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${workOfficeId}&ToDate=${toDate}&TrainingTypeId=${trainingType}&UserLoginIds=${userLoginId}&UsergroupId=${userGroupId}`;
        else if (categoryId)
          return `/api/v1//UserBasedReports/GetUserClassCompletionReport?CategoryId=${categoryId}&CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}&PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${workOfficeId}&TrainingTypeId=${trainingType}&UserLoginIds=${userLoginId}&UsergroupId=${userGroupId}`;
        else
          return `/api/v1//UserBasedReports/GetUserClassCompletionReport?CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}&PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${workOfficeId}&TrainingTypeId=${trainingType}&UserLoginIds=${userLoginId}&UsergroupId=${userGroupId}`;
      },

      GET_USER_REPORT: (
        categoryId,
        cityId,
        classId,
        countryId,
        fromDate,
        pageNumber = 1,
        pageSize = 20,
        stateId,
        toDate,
        workOfficeId,
        trainingType,
        userId,
        userGroupId,
      ) => {
        if (fromDate && toDate)
          return `/api/v1//UserBasedReports/GetUserReport?cityId=${cityId}&classId=${classId}&countryId=${countryId}&fromDate=${fromDate}&pageNum=${pageNumber}&pageSize=${pageSize}&stateId=${stateId}&storeId=${workOfficeId}&toDate=${toDate}&trainingTypeid=${trainingType}&userId=${userId}&usergroupId=${userGroupId}`;
        else if (categoryId)
          return `/api/v1//UserBasedReports/GetUserReport?categoryId=${categoryId}&cityId=${cityId}&classId=${classId}&countryId=${countryId}&pageNum=${pageNumber}&pageSize=${pageSize}&stateId=${stateId}&storeId=${workOfficeId}&trainingTypeid=${trainingType}&userId=${userId}&usergroupId=${userGroupId}`;
        else
          return `/api/v1//UserBasedReports/GetUserReport?cityId=${cityId}&classId=${classId}&countryId=${countryId}&pageNum=${pageNumber}&pageSize=${pageSize}&stateId=${stateId}&storeId=${workOfficeId}&trainingTypeid=${trainingType}&userId=${userId}&usergroupId=${userGroupId}`;
      },

      GET_SEARCH_CLASS_NAME: (ClassName) =>
        `/api/v1/ShotClass/GetSearchClasses?SearchText=${ClassName}&Status=Published`,
      GET_SEARCH_USER_GROUP: (userGroup) =>
        `/api/v1/UserGroup/GetUserGroup?searchKey=${userGroup}`,

      //harshil
      GET_COMPREHENSIVE_REPORT_CSV: (url) =>
        `/api/v1/Download/Export?url=${url}&template=UserReport`,

      GET_TABULAR_REPORT_CSV: (
        userId,
        usergroupId = 0,
        classId,
        trainingTypeId = 0,
        categoryId = null,
        fromDate = null,
        toDate = null,
        countryId,
        stateId = 0,
        cityId = 0,
        storeId = 0,
        pageNumber = 1,
        pageSize = 20,
      ) => {
        // &categoryId=${categoryId}&FromDate=${fromDate}&ToDate=${toDate}
        return `/api/v1//UserBasedReports/GetUserClassCompletionReportCSV?CityId=${cityId}&ClassId=${classId}&CountryId=${countryId}
        &PageNum=${pageNumber}&PageSize=${pageSize}&StateId=${stateId}&StoreId=${storeId}
        &TrainingTypeId=${trainingTypeId}&UserLoginIds=${userId}&UsergroupId=${usergroupId}`;
      },
      // GET_TABULAR_REPORT_CSV: (
      //   usergroupId,
      //   classId,
      //   trainingTypeId,
      //   categoryId,
      //   fromDate,
      //   toDate,
      //   countryId,
      //   stateId,
      //   cityId,
      //   storeId
      // ) =>
      //   `/api/v1/Download/Export?url=https%3A%2F%2Fdev1services.shotclasses.com%2Fapi%2Fv1%2F%2FUserBasedReports%2FGetUserClassCompletionReport%3FusergroupId%3D${
      //     usergroupId ? usergroupId : 0
      //   }%26shotClassId%3D${classId}%26trainingTypeid%3D${
      //     trainingTypeId ? trainingTypeId : 0
      //   }%26categoryId%3D${categoryId ? categoryId : null}%26fromDate%3D${
      //     fromDate ? fromDate : null
      //   }%26toDate%3D${toDate ? toDate : null}%26countryId%3D${
      //     countryId ? countryId : 0
      //   }%26stateId%3D${stateId ? stateId : 0}%26cityId%3D${
      //     cityId ? cityId : 0
      //   }%26storeId%3D${
      //     storeId ? storeId : 0
      //   }&template=UserClassCompletionReport`,
    },
    ANALYTICAL_REPORT: {
      GET_DEFAULT_SHOTCLASS_INFORMATION: `api/v1//VisualReports/AnalyticalReport/GetDefaultShotClassInformation`,
    },
    SURVEY_REPORT: {
      GET_CLASS_WITH_SURVEY: (isScoredSurvey = false) => {
        return `/api/v1//ShotClass/GetAllClassesWithSurvey?locale=en-GB&IsScoredSurvey=${isScoredSurvey}`;
      },
      GET_SURVEY_REPORT: (classId, reportMode, template, surveyId) => {
        if (reportMode === "Extract")
          return `/api/v1//ShotClass/GetSurveyAllReportData?shotClassId=${classId}&locale=en-GB${
            template !== "" ? `&template=${template}` : ""
          } ${surveyId !== "" ? `&SurveyId=${surveyId}` : ""}`;
        else
          return `/api/v1//ShotClass/GetSurveyReportData?locale=en-GB&shotClassId=${classId}`;
      },
    },
    QUIZ_REPORT: {
      GET_QUIZ_REPORT: (
        classNames,
        fromDate,
        pageNumber = 0,
        pageSize = 0,
        toDate,
        userId = 0,
        groupId,
        reportMode,
      ) => {
        if (reportMode === "Extract")
          return `/api/v1/Reports/QuizPerformanceReport/GetQuizPerformanceReportToExport?PageNum=${pageNumber}&PageSize=${pageSize}&StartDate=${fromDate}&EndDate=${toDate}&ClassNames=${
            classNames ? classNames : ""
          }&UserId=${userId ? userId : 0}&UserGroupsIds=${
            groupId ? groupId : ""
          }`;
        else
          return `/api/v1//Reports/QuizPerformanceReport/GetQuizPerformanceReport?PageNum=${pageNumber}&PageSize=${pageSize}&StartDate=${fromDate}&EndDate=${toDate}&ClassNames=${
            classNames ? classNames : ""
          }&UserId=${userId}&UserGroupsIds=${groupId}`;
      },
      GET_DRILLDOWN_QUIZ_REPORT: (classId, pageNum, pageSize, reportMode) => {
        if (reportMode === "Extract")
          return `/api/v1/Reports/QuizPerformanceReport/GetQuestionsInClassToExport?classId=${classId}&pageNum=${pageNum}&pageSize=${pageSize}`;
        else
          return `/api/v1//Reports/QuizPerformanceReport/GetQuizDrillDownDetails?ClassId=${classId}&PageNum=${pageNum}&PageSize=${pageSize}`;
      },
      GET_USER_RESPONSE_TO_QUESTIONS: (
        questionID,
        pageNum,
        pageSize,
        filterParam,
        userName,
      ) =>
        `/api/v1//Reports/QuizPerformanceReport/GetUserResponseToQuestion?questionID=${questionID}&PageNum=${pageNum}&PageSize=${pageSize}&filterParam=${filterParam}&UserName=${userName}`,
    },
    ACCESS_REPORT: {
      GET_ACCESS_REPORT: `/api/v1//Reports/ApplicationAccessReport/AccessReport?`,
      GET_APPLICATION_ACCESS_USER_DETAILS: (
        userId,
        fromDate,
        toDate,
        timeZone,
        reportMode,
      ) =>
        `/api/v1//Reports/ApplicationAccessReport/ApplicationAccessUserDetails?userId=${userId}&StartDate=${fromDate}&EndDate=${toDate}&Timezone=${timeZone}`,
      GET_ACCESS_REPORT_CSV: (
        userGroupIds,
        timeZone,
        fromDate,
        toDate,
        userId,
      ) =>
        `/api/v1//Reports/ApplicationAccessReport/DownloadAccessReportCsv?fromDate=${fromDate}&pageNum=0&pageSize=0&timeZone=${timeZone}&toDate=${toDate}&userGroups=${userGroupIds}&userId=${userId}`,
      GET_ACCESS_DETAILED_REPORT_CSV: (
        userGroupIds,
        timeZone,
        fromDate,
        toDate,
        userId,
      ) =>
        `/api/v1//Reports/ApplicationAccessReport/DownloadApplicationAccessUserDetailsCsv?StartDate=${fromDate}&PageNum=0&PageSize=0&TimeZone=${timeZone}&EndDate=${toDate}&userGroups=${userGroupIds}&UserId=${userId}`,
      GET_AAD_APPLICATION_ACCESS_REPORT: `/api/v1/AADAccessReport/GetAADApplicationAccessReport`,
      GET_AAD_USER_ACCESS_DETAILS_REPORT: (loginId, startDate, endDate) =>
        `/api/v1/AADAccessReport/GetAADUserAccessDetailsReport?loginId=${loginId}&startDate=${startDate}&endDate=${endDate}`,
      GET_AAD_USER_ACCESS_DETAIL_REPORT_CSV: (url) =>
        `/api/v1/Download/Export?url=${url}`,
      GET_AAD_APPLICATION_ACCESS_REPORT_CSV: (
        fromDate,
        toDate,
        userId,
        userGroupIds,
      ) =>
        `/api/v1/AADAccessReport/GetAADApplicationAccessReport?StartDate=${fromDate}&EndDate=${toDate}&UserId=${userId}&userGroups=${userGroupIds}`,
    },
    ADOPTION_REPORT: {
      GET_TOTAL_ACTIVE_USERS: (fromDate, toDate, userGroupId) =>
        `/api/v1//Reports/AdoptionReport/GetTotalActiveUsersFromUserGroups?fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_MOBILE_INSTALLATION_TREND: (classId, fromDate, toDate, userGroupId) =>
        `/api/v1//Reports/AdoptionReport/GetMobileAppInstallationTrendDetails?classId=${classId}&fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_USERGROUP_ACCESS_DETAILS: (classId, fromDate, toDate, userGroupId) =>
        `/api/v1//Reports/AdoptionReport/GetUserGroupAppAccessDetails?classId=${classId}&fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_USERGROUP_CLASS_USAGE_DETAILS: (
        classId,
        fromDate,
        toDate,
        userGroupId,
      ) =>
        `/api/v1//Reports/AdoptionReport/GetUserGroupAndClassesUsageDetails?classId=${classId}&fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_SHOTCLASS_COMPLETION_TREND: (
        classId,
        fromDate,
        toDate,
        userGroupId,
      ) =>
        `/api/v1//Reports/AdoptionReport/GetShotClassCompletionTrendDetails?classId=${classId}&fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_CLASS_WISE_USAGE_DETAILS: (classId, fromDate, toDate, userGroupId) =>
        `/api/v1//Reports/AdoptionReport/GetClassWiseUsageDetails?classId=${classId}&fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_NUMBER_OF_USER_ACCESSED_SHOTCLASS_APPLICATION: (
        fromDate,
        toDate,
        userGroupId,
      ) =>
        `/api/v1//Reports/AdoptionReport/GetNoOfUsersAccessedShotClassApplication?fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_NUMBER_OF_USER_ACCESSED_SHOTCLASSESS: (
        fromDate,
        toDate,
        userGroupId,
      ) =>
        `/api/v1//Reports/AdoptionReport/GetNoOfUsersAccessedShotClasses?fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
      GET_MOBILE_APP_INSTALLATION_COUNT: (fromDate, toDate, userGroupId) =>
        `/api/v1//Reports/AdoptionReport/GetMobileAppInstallationCount?fromDate=${fromDate}&toDate=${toDate}&userGroupsId=${userGroupId}`,
    },
  },
};

//-------------------------Mediakind License Keys-----------------------------
export const MKPLAYER_LICENSE_KEY = "d0167b1c-9767-4287-9ddc-e0fa09d31e02";

export const SHOTCLASS_ROOT_API_URL = apiConstants.BASE_URL_1;
export const START_SESSION_API_URL = SHOTCLASS_ROOT_API_URL + "/api/v1/User/StartSession";
export const END_SESSION_API_URL = SHOTCLASS_ROOT_API_URL + "/api/v1/User/EndSession";
//-------------------------End Mediakind License Keys-------------------------
